import { useEffect, useState } from 'react';

/**
 * A debounced copy of `value` and whether it has caught up with the live value.
 * `settled` lets callers hold back actions (e.g. submit) while a request derived
 * from the debounced value is still stale. Values must be JSON-serializable.
 */
export function useDebouncedValue<T>(value: T, delay: number) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  const settled = JSON.stringify(value) === JSON.stringify(debounced);
  return { debounced, settled };
}
